import { useNavigate } from "react-router-dom";
import { stopImpersonation, useImpersonation } from "@/hooks/useAuth";
import { useCurrentUser } from "@/hooks/useCurrentUser";

/**
 * Sticky bar shown app-wide while an admin is viewing the app as another user.
 * "View as" is read-only — Firestore rules only grant admins read access to
 * other users' data, so any write attempt fails at the rules layer. The banner
 * makes the mode obvious and offers a one-click exit back to the user detail.
 */
export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUserId } = useImpersonation();
  const { user } = useCurrentUser();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedUserId) return null;

  const label = user?.email ?? user?.displayName ?? impersonatedUserId;

  const exit = () => {
    stopImpersonation();
    navigate(`/app/admin/users/${impersonatedUserId}`);
  };

  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
        padding: "8px 16px",
        background: "var(--warn)",
        color: "var(--paper)",
        fontSize: 13,
        position: "sticky",
        top: 0,
        zIndex: 50,
      }}
    >
      <span>
        Viewing as <strong>{label}</strong> · read-only
      </span>
      <button
        type="button"
        className="btn btn-sm"
        onClick={exit}
        style={{ background: "var(--paper)", color: "var(--warn)", border: "none" }}
      >
        Exit
      </button>
    </div>
  );
}
